<template>
  <v-row class="mb-1">
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn
              style="border-radius: 12px"
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              @click="$emit('openSearchItemsDialog')"
            >
              <v-icon class="icon-glass">mdi-magnify</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ $t("$vuetify.tooltips.searchItems") }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-menu bottom right>
        <template v-slot:activator="{ on: onMenu }">
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on: onTooltip }">
              <div v-on="items && items.length > 0 ? { ...onMenu, ...onTooltip } : onTooltip">
                <v-btn
                  block
                  tile
                  depressed
                  width="100%"
                  height="3.4rem"
                  icon
                  :style="
                    items && items.length > 0
                      ? {
                          'font-weight': 'bold',
                          'background': 'linear-gradient(135deg, rgba(87, 74, 144, 1) 0%, rgba(106, 77, 174, 1) 50%, rgba(87, 74, 144, 1) 100%)',
                          'border-radius': '12px',
                          'color': 'white'
                        }
                      : {
                          'background-color': '#E0E0E0 !important',
                          'font-weight': 'bold',
                          'border-radius': '12px',
                          'cursor': 'not-allowed'
                        }
                  "
                  :disabled="!(items && items.length > 0)"
                >
                  Wolt
                </v-btn>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.wolt") }}</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item
            v-for="(menu, idx) in paymentMenu"
            :key="idx"
            @click="menuPaymentClick(menu, 'wolt')"
          >
            <v-list-item-title v-if="menu.type === 'G' || menu.type === 'V'">{{
              menu.text
            }}</v-list-item-title>
            <v-list-item-title v-else>{{ menu.text }} </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-menu bottom right>
        <template v-slot:activator="{ on: onMenu }">
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on: onTooltip }">
              <div v-on="items && items.length > 0 ? { ...onMenu, ...onTooltip } : onTooltip">
                <v-btn
                  block
                  tile
                  depressed
                  width="100%"
                  height="3.4rem"
                  icon
                  :style="
                    items && items.length > 0
                      ? {
                          'font-weight': 'bold',
                          'background': 'linear-gradient(135deg, rgba(87, 74, 144, 1) 0%, rgba(106, 77, 174, 1) 50%, rgba(87, 74, 144, 1) 100%)',
                          'border-radius': '12px',
                          'color': 'white'
                        }
                      : {
                          'background-color': '#E0E0E0 !important',
                          'font-weight': 'bold',
                          'border-radius': '12px',
                          'cursor': 'not-allowed'
                        }
                  "
                  :disabled="!(items && items.length > 0)"
                >
                  Bolt
                </v-btn>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.bolt") }}</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item
            v-for="(menu, idx) in paymentMenu"
            :key="idx"
            @click="menuPaymentClick(menu, 'bolt')"
          >
            <v-list-item-title v-if="menu.type === 'G' || menu.type === 'V'">{{
              menu.text
            }}</v-list-item-title>
            <v-list-item-title v-else>{{ menu.text }} </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-menu bottom right>
        <template v-slot:activator="{ on: onMenu }">
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on: onTooltip }">
              <div v-on="items && items.length > 0 ? { ...onMenu, ...onTooltip } : onTooltip">
                <v-btn
                  block
                  tile
                  depressed
                  width="100%"
                  height="3.4rem"
                  icon
                  :style="
                    items && items.length > 0
                      ? {
                          'font-weight': 'bold',
                          'background': 'linear-gradient(135deg, rgba(87, 74, 144, 1) 0%, rgba(106, 77, 174, 1) 50%, rgba(87, 74, 144, 1) 100%)',
                          'border-radius': '12px',
                          'color': 'white'
                        }
                      : {
                          'background-color': '#E0E0E0 !important',
                          'font-weight': 'bold',
                          'border-radius': '12px',
                          'cursor': 'not-allowed'
                        }
                  "
                  :disabled="!(items && items.length > 0)"
                >
                  Glovo
                </v-btn>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.glovo") }}</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item
            v-for="(menu, idx) in paymentMenu"
            :key="idx"
            @click="menuPaymentClick(menu, 'glovo')"
          >
            <v-list-item-title v-if="menu.type === 'G' || menu.type === 'V'">{{
              menu.text
            }}</v-list-item-title>
            <v-list-item-title v-else>{{ menu.text }} </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn
              style="border-radius: 12px"
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              @click="$emit('openReceiptsDialog')"
            >
              <v-icon class="icon-glass">mdi-receipt-text</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ $t("$vuetify.tooltips.receiptsDialog") }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn
              style="border-radius: 12px"
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              @click="$emit('openCloseBalanceDialog')"
            >
              <v-icon class="icon-glass">mdi-cash-register</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ $t("$vuetify.tooltips.closeBalance") }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import state from '@/state'
import EventBus from '@/plugins/event-bus'

export default {
  data: function () {
    return {
      deliveries: [{
        name: 'Wolt', value: 'wolt'
      },
      {
        name: 'Glovo', value: 'glovo'
      },
      {
        name: 'Bolt Food', value: 'bolt'
      }],
      paymentMenu: [
        { text: this.$t('$vuetify.paymentMethods.cashMethod'), type: 'G', icon: 'mdi-cash' },
        { text: this.$t('$vuetify.paymentMethods.cardMethod'), type: 'K', icon: 'mdi-card' }
      ],
      tooltipDelay: 500
      // paymentMenu: [
      //   { text: this.$t('$vuetify.paymentMethods.cash'), type: 'G', icon: 'mdi-cash' },
      //   { text: this.$t('$vuetify.paymentMethods.card'), type: 'K', icon: 'mdi-card' }
      // ],
      // availableCards: [
      //   { text: 'Visa', type: 'VISA', icon: 'mdi-cash' },
      //   { text: 'Maestro', type: 'MAESTRO', icon: 'mdi-card' },
      //   { text: 'Master Card', type: 'MASTER', icon: 'mdi-card' },
      //   { text: 'American Express', type: 'AMERICAN', icon: 'mdi-card' }
      // ]
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    receiptNote: {
      type: Object,
      default: () => undefined
    }
  },
  methods: {
    openReceiptNoteDialog () {
      this.$refs.addReceiptNoteDialog.open(this.receiptNote)
    },
    menuPaymentClick (menu, deliveryService) {
      switch (menu.type) {
        case 'G':
          this.$emit('deliveryFinishSimplePayment', deliveryService, 'G')
          break
        case 'K':
          this.$emit('deliveryFinishSimplePayment', deliveryService, 'O')
          break
      }
    }
  },
  mounted () {
    EventBus.$off('open_receipts')
    EventBus.$on('open_receipts', () => {
      this.$emit('openReceiptsDialog')
    })
  },

  created () {
    this.tooltipDelay = state.getTooltipDelay()
  }
}
</script>

<style scoped>
/* Purple Toolbar/Save Buttons Glass-morphism Styles */
.save-btn-glass {
  background: linear-gradient(135deg, rgba(87, 74, 144, 1) 0%, rgba(106, 77, 174, 1) 50%, rgba(87, 74, 144, 1) 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(87, 74, 144, 0.45) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 12px !important;
}

.save-btn-glass:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(77, 64, 124, 1) 0%, rgba(96, 67, 154, 1) 50%, rgba(77, 64, 124, 1) 100%) !important;
  box-shadow: 0 8px 20px rgba(87, 74, 144, 0.7) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px) scale(1.02);
}

.save-btn-glass:disabled {
  opacity: 0.6 !important;
  background: linear-gradient(135deg, rgba(97, 84, 164, 0.3) 0%, rgba(126, 87, 194, 0.25) 50%, rgba(97, 84, 164, 0.3) 100%) !important;
  box-shadow: 0 1px 4px rgba(97, 84, 164, 0.1) !important;
}

.save-btn-glass:disabled .icon-glass {
  color: rgba(255, 255, 255, 0.5) !important;
}

.icon-glass {
  color: white !important;
}
</style>
